import { render, staticRenderFns } from "./ProductModifyList.vue?vue&type=template&id=49dfd43f&scoped=true&"
import script from "./ProductModifyList.vue?vue&type=script&lang=js&"
export * from "./ProductModifyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49dfd43f",
  null
  
)

export default component.exports